import { css } from '@emotion/react';

import { screens } from '../shared/styles';

export const wrapperStyles = css`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const textareaBase = css`
  width: 100%;
  box-sizing: border-box;
  font: inherit;
  color: var(--text-primary);
  background-color: var(--surface-page);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  padding: var(--spacing-4);
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  outline: none;
  resize: none;
  overscroll-behavior: contain;
  overscroll-behavior-y: contain;

  @media (max-width: calc(${screens.lg} - 1px)) {
    font-size: 16px;
  }

  &::placeholder {
    color: var(--text-secondary);
  }

  &:focus {
    border-color: var(--border-focus);
    box-shadow: 0 0 0 3px var(--surface-success, rgba(50, 90, 60, 0.1));
  }

  &:disabled {
    background-color: var(--surface-disabled-2);
    color: var(--text-on-disabled);
    cursor: not-allowed;
  }

  &:read-only {
    background-color: var(--surface-disabled-2);
    color: var(--text-secondary);
    cursor: default;
  }
`;

export const variantError = css`
  border-color: var(--border-error);
  &:focus {
    border-color: var(--border-error);
    box-shadow: 0 0 0 3px var(--color-error-100);
  }
`;

export const variantSuccess = css`
  border-color: var(--color-success-500);
  &:focus {
    border-color: var(--color-success-500);
    box-shadow: 0 0 0 3px var(--color-success-100);
  }
`;

export const submitButtonContainer = css`
  position: absolute;
  right: var(--spacing-4);
  bottom: var(--spacing-4);
`;

export const textareaWithSubmit = css`
  padding-right: var(--spacing-16);
`;
